import { BillingAddressInput, DebitDetailsInput, UpdateDebitInfoInput, UpdateDebitInfoResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { nullifyLine2 } from '../../helpers/validators/address.helper';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const updateDebitInfo = async (appId: number, debitDetails: DebitDetailsInput, address: BillingAddressInput): Promise<UpdateDebitInfoResponse | undefined> => {
  try {
    const debitInfo: UpdateDebitInfoInput = {
      applicationId: appId,
      debitDetails: debitDetails,
      billingAddress: nullifyLine2(address),
    };

    const { data } = await applicationFormService.updateDebitInfo(debitInfo);
    return data?.updateDebitInfo as UpdateDebitInfoResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
        break;
    }
    throw error;
  }
};

export default updateDebitInfo;
